(() => {
  const tag = document.getElementById('myc-posthog-shopify');
  if (!tag || window.mycPosthogShopifyInstalled) return;
  window.mycPosthogShopifyInstalled = true;
  const token = tag.dataset.projectToken;
  const apiHost = tag.dataset.apiHost;
  const storageKey = 'myc_posthog_shopify_session_v1';
  const privatePath = /\/(?:account|checkouts?|orders)(?:\/|$)/;
  if (!token || !apiHost || privatePath.test(location.pathname)) return;
  let sdk;
  let loading = false;
  let timer;

  function allowed() {
    return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
  }

  function safeUrl(value) {
    try {
      const url = new URL(value, location.origin);
      if (!['http:', 'https:'].includes(url.protocol)) return undefined;
      const path = privatePath.test(url.pathname) ? '/private/' : url.pathname;
      return `${url.origin}${path}`;
    } catch { return undefined; }
  }

  function bridge() {
    try {
      const session = JSON.parse(localStorage.getItem(storageKey));
      const now = Date.now();
      if (session?.clientId && /^[0-9a-f-]{36}$/i.test(session.id) &&
          Number.isFinite(session.last) && Number.isFinite(session.started) &&
          now - session.last < 1800000 && now - session.started < 86400000) return session;
    } catch {}
  }

  function beforeSend(event) {
    if (!allowed()) return null;
    if (event.event === '$pageview') return null;
    const properties = event.properties;
    for (const key of Object.keys(properties)) {
      if (/(?:url|referrer|href)$/i.test(key) && typeof properties[key] === 'string') {
        properties[key] = safeUrl(properties[key]);
      }
    }
    delete properties.$set;
    delete properties.$set_once;
    properties.$ip = null;
    properties.storefront_platform = 'shopify';
    properties.storefront_environment = location.hostname === 'ej9vth-dj.myshopify.com' ? 'preview' : 'production';
    properties.capture_source = 'shopify_theme';
    return event;
  }

  function initialize() {
    loading = false;
    const session = bridge();
    if (!allowed() || !session || !window.posthog?.init) return;
    sdk = window.posthog.init(token, {
      api_host: apiHost,
      ui_host: 'https://eu.posthog.com',
      defaults: '2026-08-30',
      bootstrap: { distinctID: `shopify:${session.clientId}`, isIdentifiedID: false, sessionID: session.id },
      persistence: 'memory',
      person_profiles: 'never',
      capture_pageview: true,
      capture_pageleave: true,
      enable_heatmaps: true,
      autocapture: { dom_event_allowlist: ['click'], capture_copied_text: false },
      mask_all_text: true,
      mask_all_element_attributes: true,
      capture_performance: false,
      capture_exceptions: false,
      enable_recording_console_log: false,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '[data-ph-mask], .ph-mask, .customer, .contact__fields, .recipient-form, .product-option, [data-customer], [data-customer-name], [data-customer-email], [data-customer-address], [id*="cart-note"], [id*="cart-custom-field"], form [role="alert"]',
        blockSelector: '[contenteditable], iframe, [data-ph-block], .ph-no-capture, [x-data-properties], [x-data*="cart_note"], [data-customer], [data-customer-name], [data-customer-email], [data-customer-address]',
        recordCrossOriginIframes: false,
        recordCanvas: false,
        maskNetworkRequestFn: request => ({ ...request, url: safeUrl(request.url) })
      },
      before_send: beforeSend,
      loaded: instance => {
        if (!allowed()) { instance.opt_out_capturing(); return; }
        instance.register({ storefront_platform: 'shopify', storefront_environment: location.hostname === 'ej9vth-dj.myshopify.com' ? 'preview' : 'production', capture_source: 'shopify_theme' });
        instance.capture('storefront_replay_ready', { integration_version: '1.1.1' });
      }
    });
  }

  function reconcile() {
    clearTimeout(timer);
    if (!allowed()) {
      if (sdk) {
        sdk.stopSessionRecording();
        sdk.opt_out_capturing();
      }
      return;
    }
    if (sdk) {
      if (sdk.has_opted_out_capturing()) {
        sdk.opt_in_capturing({ captureEventName: false });
        sdk.startSessionRecording();
      }
      return;
    }
    if (loading) return;
    if (!bridge()) { timer = setTimeout(reconcile, 500); return; }
    if (window.posthog?.init) { initialize(); return; }
    loading = true;
    const script = document.createElement('script');
    script.async = true;
    script.src = `${apiHost.replace('.i.posthog.com', '-assets.i.posthog.com')}/static/array.js`;
    script.onload = initialize;
    script.onerror = () => { loading = false; script.remove(); };
    document.head.appendChild(script);
  }

  document.addEventListener('visitorConsentCollected', reconcile);
  if (window.Shopify?.customerPrivacy) reconcile();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) reconcile(); });
  }
})();
